export default __webpack_public_path__ + "static/media/process_04.cb8500f7.png";